export default {
  'pages.parking-management-fee.title': 'Parking Management Fee',
  'pages.parking-management-fee.subtitle':
    'Manage parking management fee bill generation, payment and inquiry',
  'pages.parking-management-fee.tabOther': 'Other',
  'pages.parking-management-fee.batch.create': 'Batch Create',
  'pages.parking-management-fee.batch.title':
    'Batch Create Parking Management Fee Bills',
  'pages.parking-management-fee.batch.confirm': 'Confirm Create',
  'pages.parking-management-fee.batch.cancel': 'Cancel',
  'pages.parking-management-fee.batch.selectPeriodWarning':
    'Please select a period',
  'pages.parking-management-fee.batch.confirmTitle': 'Confirm Batch Create',
  'pages.parking-management-fee.batch.confirmContent':
    'Create parking management fee bills for {period}?',
  'pages.parking-management-fee.batch.success':
    'Successfully created {count} bills',
  'pages.parking-management-fee.batch.failed': 'Batch creation failed',
  'pages.parking-management-fee.table.title': 'Parking Management Fee Bills',
  'pages.parking-management-fee.columns.parking': 'Parking Space',
  'pages.parking-management-fee.columns.owner': 'Owner',
  'pages.parking-management-fee.columns.period': 'Period',
  'pages.parking-management-fee.columns.billNo': 'Bill Number',
  'pages.parking-management-fee.columns.amount': 'Final Amount',
  'pages.parking-management-fee.columns.approval': 'Approval Status',
  'pages.parking-management-fee.columns.status': 'Payment Status',
  'pages.parking-management-fee.columns.paymentAmount': 'Payment Amount',
  'pages.parking-management-fee.columns.paymentTime': 'Payment Time',
  'pages.parking-management-fee.columns.dueAmount': 'Due',
  'pages.parking-management-fee.columns.actualAmount': 'Paid',
  'pages.parking-management-fee.columns.operations': 'Operations',
  'pages.parking-management-fee.action.create': 'Create Bill',
  'pages.parking-management-fee.action.view': 'View',
  'pages.parking-management-fee.action.edit': 'Edit',
  'pages.parking-management-fee.action.audit': 'Submit for Audit',
  'pages.parking-management-fee.action.batchDelete': 'Batch Delete',
  'pages.parking-management-fee.form.createTitle':
    'Create Parking Management Fee Bill',
  'pages.parking-management-fee.form.editTitle':
    'Edit Parking Management Fee Bill',
  'pages.parking-management-fee.form.parking': 'Parking Space',
  'pages.parking-management-fee.form.selectParking':
    'Please select a parking space',
  'pages.parking-management-fee.form.select': 'Select',
  'pages.parking-management-fee.form.priceConfig': 'Fee Configuration',
  'pages.parking-management-fee.form.period': 'Period',
  'pages.parking-management-fee.form.amount': 'Amount',
  'pages.parking-management-fee.form.finalAmount': 'Final Amount',
  'pages.parking-management-fee.form.remarks': 'Remarks',
  'pages.parking-management-fee.detail.title':
    'Parking Management Fee Bill Details',
  'pages.parking-management-fee.message.saveSuccess': 'Saved successfully',
  'pages.parking-management-fee.message.saveFailed': 'Save failed',
  'pages.parking-management-fee.message.detailFailed':
    'Failed to load bill details',
  'pages.parking-management-fee.message.deleteConfirm': 'Delete this bill?',
  'pages.parking-management-fee.message.deleteSuccess': 'Deleted successfully',
  'pages.parking-management-fee.message.deleteFailed': 'Delete failed',
  'pages.parking-management-fee.message.batchDeleteConfirm':
    'Confirm batch deletion',
  'pages.parking-management-fee.message.batchDeleteContent':
    'Delete the selected {count} draft or rejected bills?',
  'pages.parking-management-fee.message.batchDeleteDraftOnly':
    'Only draft or rejected bills can be deleted',
  'pages.parking-management-fee.message.selectAuditWarning':
    'Please select bills to submit for audit',
  'pages.parking-management-fee.message.auditConfirm':
    'Submit selected bills for audit?',
  'pages.parking-management-fee.message.auditSuccess': 'Submitted for audit',
  'pages.parking-management-fee.message.auditFailed': 'Audit submission failed',
  'pages.parking-management-fee.detail.billNo': 'Bill Number',
  'pages.parking-management-fee.detail.parking': 'Parking Space',
  'pages.parking-management-fee.detail.owner': 'Owner',
  'pages.parking-management-fee.detail.period': 'Period',
  'pages.parking-management-fee.detail.amount': 'Amount Due',
  'pages.parking-management-fee.detail.status': 'Payment Status',
  'pages.parking-management-fee.detail.approval': 'Approval Status',
  'pages.parking-management-fee.detail.basicInfo': 'Basic Information',
  'pages.parking-management-fee.detail.paymentStatus': 'Payment Status',
  'pages.parking-management-fee.detail.approvalStatus': 'Approval Status',
  'pages.parking-management-fee.detail.startDate': 'Start Date',
  'pages.parking-management-fee.detail.endDate': 'End Date',
  'pages.parking-management-fee.detail.parkingOwnerInfo':
    'Parking & Owner Information',
  'pages.parking-management-fee.detail.parkingInfo': 'Parking Information',
  'pages.parking-management-fee.detail.ownerInfo': 'Owner Information',
  'pages.parking-management-fee.detail.ownerId': 'Owner ID',
  'pages.parking-management-fee.detail.ownerIdCard': 'ID Card',
  'pages.parking-management-fee.detail.ownerEmail': 'Email',
  'pages.parking-management-fee.detail.amountInfo': 'Amount Information',
  'pages.parking-management-fee.detail.baseAmount': 'Base Amount',
  'pages.parking-management-fee.detail.lateFee': 'Late Fee',
  'pages.parking-management-fee.detail.discountAmount': 'Discount Amount',
  'pages.parking-management-fee.detail.finalAmount': 'Final Amount',
  'pages.parking-management-fee.detail.paymentInfo': 'Payment Information',
  'pages.parking-management-fee.detail.paymentMethod': 'Payment Method',
  'pages.parking-management-fee.detail.paymentReference': 'Payment Reference',
  'pages.parking-management-fee.detail.systemInfo': 'System Information',
  'pages.parking-management-fee.detail.createdTime': 'Created Time',
  'pages.parking-management-fee.detail.updatedTime': 'Updated Time',
  'pages.parking-management-fee.detail.dueDate': 'Due Date',
  'pages.parking-management-fee.detail.paidDate': 'Payment Time',
  'pages.parking-management-fee.detail.remarks': 'Remarks',
  'pages.parking-management-fee.detail.auditRecords': 'Audit Records',
  'pages.parking-management-fee.detail.loading': 'Loading...',
  'pages.parking-management-fee.detail.noRecords': 'No audit records',
  'pages.parking-management-fee.audit.title':
    'Submit Parking Management Fee for Audit',
  'pages.parking-management-fee.audit.name': 'Audit Name',
  'pages.parking-management-fee.audit.remark': 'Submission Remark',
};
